window.postProcessClosePopup = el => {
  // for now reset form commented
  // document.querySelector('form').reset()
  const popupEl = el?.getAttribute('data-back-popup')
  if (popupEl) {
    const popup = document.querySelector(popupEl)
    if (popup) {
      popup.classList.add('show')
    }
  }
}

$(document).ready(function() {
  openModalGift();
  document.querySelectorAll('.overlay').forEach((c) => {
    c.addEventListener('click', () => {
      handleClosePopup();
    })
  })
  document.querySelectorAll('.close').forEach((c) => {
    c.addEventListener('click', () => {
      handleClosePopup();
    })
  })
  document.querySelectorAll('.popup-wrapper').forEach(popup => {
    document.addEventListener('swiped-down', () => {
      popup.classList.remove('show')
      postProcessClosePopup(popup)
    })
    // popup.querySelector('.overlay').addEventListener('click', e => {
    //   e.stopPropagation()
    //   popup.classList.remove('show')
    // })
    // popup.querySelectorAll('.close').forEach(el => {
    //   el.addEventListener('click', e => {
    //     e.stopPropagation()
    //     popup.classList.remove('show')
    //   })
    // })
    popup.querySelectorAll('.back-action').forEach(el => {
      el.addEventListener('click', e => {
        e.stopPropagation()
        popup.classList.remove('show')
        postProcessClosePopup(popup)
      })
    })
  })
  // On scape
  document.addEventListener('keyup', e => {
    if (e.key === 'Escape') {
      // for now reset form commented
      // document.querySelector('form').reset()
      document.querySelectorAll('.popup-wrapper').forEach(popup => {
        popup.classList.remove('show')
      })
    }
  })

  // document.querySelector('.root-date-input ')._flatpickr.selectedDates
})

const handleClosePopup = () => {
  document.querySelectorAll('.popup-wrapper').forEach((el) => {
    el.classList.remove('show')
    document.querySelector('body').style.overflowY = 'scroll'
  })
}

const openModalGift = () => {
  setTimeout(function(){
    var $popup = $('#modal-receive-gift')
    if ($popup.length >= 1) {
      $popup.modal('show');
    }
  }, 500);
}

window.closeAllPopup = () => {
  // for now reset form commented
  // document.querySelector('form').reset()
  const otherPopups = document.querySelectorAll('.popup-wrapper')
  otherPopups.forEach(popup => {
    popup.classList.remove('show')
  })
}

const handleTriggerPopup = t => {
  closeAllPopup()

  const popups = document.querySelectorAll(t.getAttribute('data-popup'))
  popups.forEach(popup => {
    popup.classList.add('show')
  })
}

window.hideAllField = () => {
  document.querySelectorAll('[data-popup]').forEach(el => {
    var element = document.querySelector(`#${el.dataset.idField}`)
    if (element != null) {
      element.classList.add('d-none')
    }
  })
}

window.showField = el => {
  hideAllField()
  var textTitle = document.querySelector('#textTitle')
  if (textTitle != null) {
    textTitle.textContent = el.dataset.textTitle
  }

  var idField = document.querySelector(`#${el.dataset.idField}`)
  if (idField != null) {
    idField.classList.remove('d-none')
  }
}

window.loadFile = event => {
  var image_url = window.URL.createObjectURL(event.target.files[0])
  var image_tag = document.querySelector('#output')

  image_tag.src = image_url

  document.querySelector('form').submit()
}

window.merchantData = el => {
  var merchant_id = el.dataset.merchantId

  if (merchant_id != undefined) {
    var merchant_data  = document.querySelector(`#data-merchant-id-${merchant_id}`)
    var dataset        = merchant_data.dataset
    var targetAttrGmap = true
    var targetAttrWaze = true

    var merchant_name      = dataset.merchantName
    var merchant_address   = dataset.merchantAddress
    var merchant_category  = dataset.merchantCategory
    var merchant_gmap_link = dataset.merchantGmapLink
    var merchant_waze_link = dataset.merchantWazeLink

    var gmap_link = document.querySelector('#gmap_link')
    if (merchant_gmap_link == '') {
      merchant_gmap_link = 'javascript:;'
      targetAttrGmap     = ''
    }
    gmap_link.href   = merchant_gmap_link
    gmap_link.target = targetAttrGmap

    var waze_link = document.querySelector('#waze_link')
    if (merchant_waze_link == '') {
      merchant_waze_link = 'javascript:;'
      targetAttrWaze     = ''
    }
    waze_link.href   = merchant_waze_link
    waze_link.target = targetAttrWaze
  }
}

window.branchData = el => {
  var branch_id = el.dataset.branchId

  if (branch_id != undefined) {
    var branch_data  = document.querySelector(`#data-branch-id-${branch_id}`)
    var dataset        = branch_data.dataset
    var targetAttrGmap = true
    var targetAttrWaze = true

    var branch_name      = dataset.branchName
    var branch_address   = dataset.branchAddress
    var branch_category  = dataset.branchCategory
    var branch_gmap_link = dataset.branchGmapLink
    var branch_waze_link = dataset.branchWazeLink

    var gmap_link = document.querySelector('#gmap_link')
    if (branch_gmap_link == '') {
      branch_gmap_link = 'javascript:;'
      targetAttrGmap     = ''
      gmap_link.classList.add('d-none')
    } else {
      gmap_link.classList.remove('d-none')
    }
    gmap_link.href   = branch_gmap_link
    gmap_link.target = targetAttrGmap

    var waze_link = document.querySelector('#waze_link')
    if (branch_waze_link == '') {
      branch_waze_link = 'javascript:;'
      targetAttrWaze     = ''
      waze_link.classList.add('d-none')
    } else {
      waze_link.classList.remove('d-none')
    }
    waze_link.href   = branch_waze_link
    waze_link.target = targetAttrWaze
  }
}

document.addEventListener('click', e => {
  if (e.target.getAttribute('data-popup')) {
    e.preventDefault()
    handleTriggerPopup(e.target)
  }
})

$(document).ready(function() {
  document.querySelectorAll('[data-popup]').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      handleTriggerPopup(e.currentTarget)
      showField(el)
      merchantData(el)
      branchData(el)
    })
  })
})
